import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
export const getPaymentMethods = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.get(`/payment-methods${formatPayloadToQueryString(payload)}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar métodos de pagamento', error);
        throw error;
    }
};
export const createPaymentMethod = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/payment-methods', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao criar método de pagamento', error);
        throw error;
    }
};
export const updatePaymentMethod = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.put(`/payment-methods/${payload.id}`, payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar método de pagamento', error);
        throw error;
    }
};
export const deletePaymentMethod = async (paymentMethodId, userToken) => {
    try {
        await CoursesApiService.delete(`/payment-methods/${paymentMethodId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao deletar método de pagamento', error);
        throw error;
    }
};
export default {
    getPaymentMethods,
    createPaymentMethod,
    updatePaymentMethod,
    deletePaymentMethod
};
